import {HStack, ModalFooter, Button} from '@chakra-ui/react'
import {PropTypes} from 'prop-types'
import {useTranslation} from 'react-i18next'

const Footer = ({
  isFirstStep,
  isLastStep,
  goToPreviousStep,
  goToNextStep,
  onClose,
}) => {
  const {t} = useTranslation('invitePayers')

  return (
    <ModalFooter>
      <HStack spacing={3} width="100%" justifyContent="space-between">
        {!isFirstStep && !isLastStep && (
          <Button variant="outline" onClick={goToPreviousStep}>
            {t('modal.buttons.back')}
          </Button>
        )}
        <HStack spacing={3}>
          {isLastStep ? (
            <Button variant="primary" onClick={onClose}>
              {t('modal.buttons.finish')}
            </Button>
          ) : (
            <Button variant="primary" onClick={goToNextStep}>
              {t('modal.buttons.continue')}
            </Button>
          )}
        </HStack>
      </HStack>
    </ModalFooter>
  )
}

Footer.propTypes = {
  isFirstStep: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  goToPreviousStep: PropTypes.func.isRequired,
  goToNextStep: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default Footer
